export default __webpack_public_path__ + "static/media/142-tibet.da8c5800.svg";